<!--
  UIID: UI-Caas-MON-100
  UI Name: Monitoring List
  Modify Date: 2020/06/16
-->
<template>

  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">Parallel Process Log</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Condition search -->
    <v-row class="mb-4 custom-form-control custom-form-control-type-2 custom-form-control-type-4 custom-figma-1">
      <v-col  cols="12" class="pt-0 pb-0 mb-0">
        <v-row>
          <v-col class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1" cols="12" xl="8" lg="7" md="12">
            <v-row class="pt-0 pb-0 mt-0 mb-2">
              <v-col v-show="$cookies.get('user-admin-yn') === 'Y'" cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].PROC_ID"                  
                  :label="$t('lbl.common.conditionSearch.findbyPID')"
                  @keyup.enter="initialize"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" :lg="$cookies.get('user-admin-yn') === 'Y'? '2' : '3'" md="4" class="pt-0 pb-0 pr-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_SNDR"
                  :label="$t('lbl.common.conditionSearch.findbySender')"
                  @keyup.enter="initialize"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" :lg="$cookies.get('user-admin-yn') === 'Y'? '2' : '3'" md="4" class="pt-0 pb-0 pr-24px">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_RCVR"
                  :label="$t('lbl.common.conditionSearch.findbyReceiver')"
                  @keyup.enter="initialize"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_ID"
                  :label="$t('lbl.common.conditionSearch.findbyMessage')"
                  @keyup.enter="initialize"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="masterSearchItems.init.STATUS_TYPE"
                  :label="$t('lbl.common.conditionSearch.selectStatus')"
                  :items="statusTypes"
                 :menu-props="{offsetY: true,}"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled  
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="masterSearchItems.init.DAT_TYPE"
                  :label="$t('lbl.common.conditionSearch.dateType')"
                  :items="dateTypes"
                  :menu-props="{offsetY: true,}"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 text-right custom-figma-1" cols="12" xl="4" lg="5" md="12">
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromdate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                 <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    :label="$t('lbl.common.fromDate',[dateTimeFormat])"
                    :error-messages="masterSearchItems.init.FR_DAT_ERROR"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                 ></v-text-field>
                </template>
                <v-date-picker 
                  class="date-period-picker" 
                  v-model="masterSearchItems.init.FR_DAT" 
                  :max="getMaxDate" 
                  @input="fromdate_menu = false; changeDate('from')"
                  no-title 
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">{{$t('btn.common.cancel')}}</v-btn>
                  <v-btn text color="primary" @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)">{{$t('btn.common.ok')}}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="todate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    :error-messages="masterSearchItems.init.TO_DAT_ERROR"
                    :placeholder="$t('lbl.common.toDate',[dateTimeFormat])"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker class="date-period-picker" :allowed-dates="allowedDates" v-model="masterSearchItems.init.TO_DAT" @input="todate_menu = false; changeDate('to')" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">{{$t('btn.common.cancel')}}</v-btn>
                  <v-btn text color="primary" @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)">{{$t('btn.common.ok')}}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn class="btn-width-1 btn btn-top btn-search" color="primary" @click.native="initialize">
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{$t('btn.common.search')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
        <v-col lg="6" md="6">
        </v-col>
        <v-col lg="2" md="0">
        </v-col>
        <v-col lg="4" md="5" class="filter-search">
          <v-row>
            <v-col class="mr-0 pr-0" md="5">
              <v-select
                v-model="searchBy"
                :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                height="40"
                hide-details
                dense
                solo
                @change="onFilterTransactionLog"
                :items = searchByItems
                class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
              ></v-select>
            </v-col>
            <v-col class="ml-0 pl-0" cols="12" md="7">
              <v-text-field
                v-model="searchByTxt"
                heigth="40"
                append-icon="fa fa-search"
                :placeholder="$t('lbl.common.searchPlaceHolder')"
                hide-details
                dense
                solo
                class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                @input="onFilterTransactionLog"
                @click:append="onFilterTransactionLog"
                v-on:keyup.enter="onFilterTransactionLog"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
     </v-col>
     </v-row>
     <!-- Table content -->
     <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :page.sync="page"
          :hide-default-footer="true"
          :items-per-page="itemsPerPage"
          :height = tableHeight
          @page-count="pageCount = $event"
          class="list-table code-table"
          no-data-text="No matching records found"
          :headers="SummDataList.headers"
          :items="masterItems"
          :fixed-header="true"
          :search="searchByTxt"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="message-format-col">{{ item.RNUM }}</td>
                <td class="message-format-col">{{ item.EGI_PROC_ID }}</td>
                <td class="sender-col">{{ item.EGI_EDI_SENDER }}</td>
                <td class="receiver-col">{{ item.EGI_EDI_RECEIVER }}</td>
                <td class="message-col">{{ item.EGI_EDI_TYPE }}</td>
                <td class="message-format-col">{{ item.SMP_PROCESS_STS }}</td>
                <td v-if="item.SMP_PROCESS_STS.indexOf('CN')  !== -1 || item.SMP_PROCESS_STS.indexOf('CY')  !== -1" class="layout-col text-center"><a @click="viewFile(item)">{{$t('btn.common.view')}}</a></td>                
                <td v-else class="layout-col text-center"></td>                
                <td class="message-col">{{ item.SMP_ERR_CD }}</td>
                <td v-if="item.SMP_PROCESS_STS.indexOf('XX')  == -1" class="layout-col text-center"><a @click="viewTargetFile(item)">{{$t('btn.common.view')}}</a></td>
                <td v-else class="layout-col text-center"></td>                
                <td class="date-col">{{ item.EGI_TR_DT }}</td>
                <td class="date-col">{{ item.SMP_SRC_SND_DT }}</td>
                <td class="date-col">{{ item.SMP_RST_RCV_DT }}</td>
                <td class="message-col">{{ item.SMP_SRC_COMMS_INFO }}</td>
                </tr>
            </tbody>
          </template>          
        </v-data-table>
      </v-col>
    </v-row>
    <!-- 2021.11.23 203728 SPKA-260 hidden if no records -->
    <v-row  v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <!-- 203665 Fix issue 19 commons Update pagination by server  -->
                <div class="custom-pagi-selectbox">
                  <v-select
                    @change="handlePageSizeChange"
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox">
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ (itemsPerPage * (page-1)) +1 }} ~ {{itemsPerPage*(page - 1) + masterItems.length}} of {{totalCnt}}
                  </v-label>
                </div>
              <!-- 2021.11.23 203728 SPKA-260 first prev button -->
                <button type="button" @click="handlePageChange(1)" :class="['custom-btn-first-last-paging', page == 1 ? ' v-pagination__navigation--disabled': '']">
                  <div class="ml-2 pr-2 d-inline"><span><i class="fa fa-sm fa-step-backward"></i></span></div>
                </button>
                <button type="button" @click="changePageByTextbox(-1)" :class="['mr-3 custom-btn-first-last-paging', page-1 < 1 ? ' v-pagination__navigation--disabled': '']">
                  <div class="ml-2 pr-2 d-inline"><span><i class="fa fa-lg fa-caret-left"></i></span></div>
                </button>
                <!-- 2021.11.23 203728 SPKA-260 hidden input page number -->
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field><label>/ {{pageCount}}</label>
                <!-- 2021.11.23 203728 SPKA-260 hidden next last button -->
                <button type="button" @click="changePageByTextbox(1)" :class="['ml-3 custom-btn-first-last-paging', page+1 > pageCount ? ' v-pagination__navigation--disabled': '']">
                  <div class="mr-2 pl-2 d-inline"><span><i class="fa fa-lg fa-caret-right"></i></span></div>
                </button>
                <button type="button" @click="handlePageChange(pageCount)" :class="['custom-btn-first-last-paging', page == pageCount ? ' v-pagination__navigation--disabled': '']">
                  <div class="mr-2 pl-2 d-inline"><span><i class="fa fa-sm fa-step-forward"></i></span></div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Merge & Compare"
      :detail= "add_valid_str"
      color="validation"
    >
    </dialogWindow>   
    <dialogWindow
      ref="SearchCondition"
      size="max"
      title="Search"
      :detail="$t('msg.common.fromDateValidate')"
      color="validation"
    >
    </dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail='$t("msg.common.validateDate")'
      color="validation"
    ></dialogWindow>  
  </div>

</template>
<script>
/* globals Store */

import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import $ from "jquery"

import { debounce } from "lodash"
import { mapState } from "vuex"
import config from '@/vue-caas/config/config.js';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util'
import { beforeOneMonth } from '@/vue-dlb/utils/util'
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util'
import cfg from '@/vue-caas/config/config.js'
import idb from '@/vue-dlb/utils/idb';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import { showProgress, hideProgress } from "@/vue-dlb/utils/sys-util.js";

  const moment = require("moment");

  export default {
    components: {      
      dialogWindow,
    },

    data(){
      return{
        dateCond:true,
        tableHeight:'',
        isCreated: false,
        dateTimeFormat: '',
        show: false,        
        dialogs: [],
        dialogId: 1,
        dialog: false,
        arrLayoutDialog: [],
        edifile: "",
        bizfile: "",
        fromdate_menu: false,
        todate_menu: false,
        add_valid_str: '',
        uploadFileViewArr: [],
        totalCnt: 0,
        pageEnter: 1,
        SummDataList: {
          headers: [
            { text: 'NO', value: 'RNUM', width: "10px",},
            { text: 'PID', value: 'MST_PRCS_NO', width: "100px",},
            { text: 'Sender', value: 'MST_MSG_SNDR', width: "120px", },
            { text: 'Receiver', value: 'MST_MSG_RCVR', width: "120px", },
            { text: 'Message', value: 'MST_MSG_ID', width: "120px", },
            { text: 'Sts', value: 'MST_MSG_VER', width: "60px" },
            { text: 'Comp', value: 'MST_INPT_FIL_NM', width: "80px" },
            { text: 'Hdr/Body', value: 'MST_INPT_FIL_NM', width: "110px" },
            { text: 'Original', value: 'MST_TGT_FIL_NM', width: "80px" },
            { text: 'Translation Date', value: 'MST_TR_DT', width: "150px"  },
            { text: 'Send Date', value: 'MST_UPD_DT', width: "150px"  },
            { text: 'Response Date', value: 'MST_TRAN_DT', width: "150px" },
            { text: 'Src Comm Info', value: 'MST_TRAN_DT', width: "150px" }
          ]
        },
        masterSearchItems: {
          header: ['CUST_ID','PROC_ID', 'MSG_SNDR','MSG_RCVR','MSG_ID','STATUS_TYPE','DAT_TYPE','FR_DAT','TO_DAT', 'PAGE', 'PER_PAGE'],
          data: [{
            CUST_ID: '',
            PROC_ID: '',
            MSG_SNDR: '',
            MSG_RCVR: '',
            MSG_ID: '',
            STATUS_TYPE: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
            PAGE: 1,
            PER_PAGE: 10
          }],      
          init: {
            FR_DAT: getAppliedTimeZone(),
            TO_DAT: getAppliedTimeZone(),
            FR_DAT_PREV: getAppliedTimeZone(),
            TO_DAT_PREV: getAppliedTimeZone(),        
            FR_DAT_ERROR: [],
            TO_DAT_ERROR: [],
            STATUS_TYPE: 'ALL',
            DAT_TYPE: 'TRDT',
          }
        },            
        statusTypes:[
          {value: 'ALL', text: 'ALL'},
          {value: 'IN', text: 'Inserted Data-IN'},
          {value: 'TN', text: 'Translation Error-TN'},
          {value: 'TY', text: 'Translated-TY'},
          {value: 'SN', text: 'Sending Error-SN'},
          {value: 'SY', text: 'Sent-SY'},
          {value: 'CN', text: 'Comparison Error-CN'},
          {value: 'CY', text: 'Completed-CY'},
        ],
        dateTypes:[
          {value: 'TRDT', text: 'Translation Date'},
          {value: 'SDDT', text: 'Send Date'},
          {value: 'RSDT', text: 'Response Date'}
        ],
        searchByItems: [
          { text: 'Search by', value: 'all' },
          { text: 'ProcessID', value: 'EGI_PROC_ID' },
          { text: 'Sender', value: 'EGI_EDI_SENDER ', },
          { text: 'Receiver', value: 'EGI_EDI_RECEIVER ' },
          { text: 'Message', value: 'EGI_EDI_TYPE' }        
        ],        
        fromDateData: getAppliedTimeZone(),
        fromDate: false,
        toDateData: getAppliedTimeZone(),
        toDate: false,
        searchBy: 'all',
        searchByTxt: '',
        searchKeyBy: '',
        searchKeyByTxt: '',
        page: 1,
        pageCount: 0,
        isFilter: false,
        pageList:[
          {value: 1, text: 'Page 1'},
        ],
        itemsPerPage: 100,
        rowPerPage: [
          {value: 10, text: 'Show 10'},
          {value: 25, text: 'Show 25'},
          {value: 50, text: 'Show 50'},
          {value: 75, text: 'Show 75'},
          {value: 100, text: 'Show 100'}
        ],
      }
    },

    computed: {
      ...mapState("paproc", {
        masterItems: "masterItems"      
      }),
      getMaxDate () {
        if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
          return getAppliedTimeZone();
        }
        else {
          this.$refs.SearchCondition.dialog = true;
          return getAppliedTimeZone();
        }
      },
      getMinDate () {
        if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
          return this.masterSearchItems.init.FR_DAT;
        }
        else {
          this.$refs.SearchCondition.dialog = true;
          return this.masterSearchItems.init.FR_DAT;
        }
      },
    },

    watch: {
       listData() {
        return this.masterSearchItems;
      },
      page(){
        this.pageEnter = this.page;
      }
    },

    methods: {
      validateDateInput(dateString) {
        var regEx = /^\d{4}-\d{2}-\d{2}$/;
        if(!dateString.match(regEx)) return false;  // Invalid format
        var d = new Date(dateString);
        var dNum = d.getTime();
        if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
        return d.toISOString().slice(0,10) === dateString;
      },
      formatDate(side, evt) {
        let dateString = (side === 'from') ? this.masterSearchItems.init.FR_DAT: this.masterSearchItems.init.TO_DAT
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
          evt.preventDefault();
        } else if ((charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 4 && !dateString.includes("-")) || 
        (charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 7 && dateString[4] === '-' && ((dateString.match(/-/g) || []).length == 1))) {
          dateString += '-';
          (side === 'from') ? (this.masterSearchItems.init.FR_DAT = dateString) : (this.masterSearchItems.init.TO_DAT = dateString)
        } else {
          return true;
        }
      },
      changeDate(side) {
        if (side === 'from') {
          if(!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
            this.$refs.validateDate.dialog = true;
            this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
            this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
            return;
          }
          if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
            this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          }
          if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
            this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT
          }
        }
        if (side === 'to') {
          if(!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
            this.$refs.validateDate.dialog = true;
            this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
            this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
            return;
          }
          if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
            this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          }
          if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
            this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT
          }
        }
      },
      setSearchKeyByTxt(item){
        var inputString = item;
				inputString = inputString.replace( /\r/g , "");
				inputString = inputString.replace( /\n+/g , "\n");
				inputString = inputString.replace( /^\n|\n$/g , "");
        inputString = inputString.replace( /\n/g , ",");

        this.searchKeyByTxt = inputString;
      },            
      handlePageChange(value) {
        this.page = value;
        this.initialize('pageChange');
      },
      handlePageSizeChange(size) {
        this.itemsPerPage = size;
        this.page = 1;
        this.initialize();
      },
      initialize (pageChange) {
        if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
          console.log("--------- getList ----------");
          this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(this.masterSearchItems.init.FR_DAT);
          this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(this.masterSearchItems.init.TO_DAT);
          this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
          this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
          this.masterSearchItems.data[0].STATUS_TYPE = this.masterSearchItems.init.STATUS_TYPE;

          if(typeof pageChange == 'undefined' || pageChange != 'pageChange'){
            this.page = 1 ;
          }
          this.masterSearchItems.data[0].PAGE = this.page;
          this.masterSearchItems.data[0].PER_PAGE = this.itemsPerPage;

          Store.dispatch("paproc/getList", this.masterSearchItems).then(() => {      
            this.totalCnt = this.masterItems[0].TOTCNT;
            this.caculatePageCount();
            if(pageChange == 'pageChange' && this.pageCount<this.page){
              this.page = 1;
            }
            this.createPageList(this.pageCount);
            this.searchByTxt='';
            this.searchBy= 'all';
            this.onFilterTransactionLog();
            // 203728 - hide progress when expired time.
          });
        } else {
          this.$refs.SearchCondition.dialog = true;
        }
      },

      createPageList(pageCount){
        this.pageList=[];
        for( let i=1;i<pageCount+1;i++){
          let obj = {};
          obj.text = 'Page '+i;
          obj.value = i;
          this.pageList.push(obj);
        }
      },

      addDays (date, days) {
        let result = moment(date).add(days, "d").format("YYYY-MM-DD")
        return result;
      },

      applyGmtTimeZone(date){
        let newM = '';
        if(date !== undefined && date !== ''){
          let m = moment(date);
          let gmt = this.gmtTmzn.split(':')[0].toString();

          m.add('hours', gmt).format();
          m.format('YYYY/MM/DD HH:mm:ss');

          newM = m.format('YYYY-MM-DD HH:mm:ss');
        }
        return newM;
      },

      statusColor(status) {
        if (status.indexOf("SEND_O_DONE") !== -1)
          return "#00B8D9" ;
        else if (status.indexOf("FAIL") !== -1)
          return "#EB1E50" ;
        else if (status.indexOf(undefined) !== -1)
          return "#EB1E50" ;
        else
          return "#6F5ECE";
      },

      statusText(status, reprocessState) {
        let reProcSts = "";
        if ( reprocessState === "S" )
          reProcSts = " (Re-Send)";
        else if ( reprocessState === "T" )
          reProcSts = " (Re-Trans)";

        if ( status.indexOf("SEND_O_DONE") !== -1 )
          return `Sent${reProcSts}` ;
        else if (status.indexOf("FAIL") !== -1)
          return `Error${reProcSts}` ;
        else if (status.indexOf(undefined) !== -1)
          return `Unknown${reProcSts}` ;
        else
          return `Processing${reProcSts}`;
      },

      onFilterTransactionLog(isFilter) {
        this.isFilter = true;
        if(this.searchBy =='all' && this.searchByTxt==''){
          this.isFilter = false;
        }
        Store.commit('SET_STORE_TRANSACTION_LOG_FILTER', {filter : this.searchBy, str : this.searchByTxt});
        this.listData = this.$store.getters.monitoringList;
      },     
      viewFile (item) {      
        let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
        if (index != null) {
          window.layoutFocusView[item.ROWID.toString()]();
          return;
        }
        this.params =  {
          compfile : item.SMP_ERR_DESC,        
          ROWID : item.ROWID.toString()
        };
        this.uploadFileViewArr.push(item);
        Store.commit('paproc/SET_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));
        var w = window.open(`/paproc/CompFileView/${item.ROWID}`, '_blank', "width=1028,height=799,left=100,top=30");
        w.params = this.params;
        // 20218.7.13 203728 SPKA-153 close new window expired.
        w.newWindowExpire = true;
        w.closePopup = () => {
          let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
          this.uploadFileViewArr.splice(index, 1);
          Store.commit('paproc/DELETE_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));
          w.close();
        }
        w.focusPopup = () => {
          w.focus();
        }
        w.theme=false;
        if(this.$vuetify.theme.isDark == true){
              w.theme = this.$vuetify.theme.isDark;
        }
        if (typeof window.fileViewOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
          window.fileViewOpenWindow = {[item.ROWID.toString()] : w.closePopup};
          window.layoutFocusView = {[item.ROWID.toString()] : w.focusPopup};
        } else {
          window.fileViewOpenWindow[item.ROWID.toString()] = w.closePopup;
          window.layoutFocusView[item.ROWID.toString()] = w.focusPopup;
        }
        w.onbeforeunload = w.closePopup;
      },

      formatNumber(num) {
        return this.numberFormatter.format(num);
      },

      findIndexItem(item, arr, col) {
        let prop = (typeof col == 'undefined') ? 'id' : col;
        let index = arr.findIndex((row) => {
          return row[prop] === item[prop]
        })
        return (index > -1) ? index : null
      },

      viewTargetFile (item) {
      let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
      if (index != null) {
        window.layoutFocusView[item.ROWID.toString()]();
        return;
      }
      this.params =  {
        srcfile : item.SMP_SRC_FNAME,
        rstfile : item.SMP_RST_FNAME,
        smpfile : item.SMP_COMP_FNAME,
        ROWID : item.ROWID.toString()
      };
      this.uploadFileViewArr.push(item);
      Store.commit('paproc/SET_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));
      var w = window.open(`/paproc/TargetFileView/${item.ROWID}`, '_blank2', "width=1400,height=799,left=100,top=30");
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      w.closePopup = () => {
        let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
        this.uploadFileViewArr.splice(index, 1);
        Store.commit('paproc/DELETE_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));
        w.close();
      }
      w.focusPopup = () => {
        w.focus();
      }
      w.theme=false;
      if(this.$vuetify.theme.isDark == true){
            w.theme = this.$vuetify.theme.isDark;
      }
      if (typeof window.fileViewOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
        window.fileViewOpenWindow = {[item.ROWID.toString()] : w.closePopup};
        window.layoutFocusView = {[item.ROWID.toString()] : w.focusPopup};
      } else {
        window.fileViewOpenWindow[item.ROWID.toString()] = w.closePopup;
        window.layoutFocusView[item.ROWID.toString()] = w.focusPopup;
      }
      w.onbeforeunload = w.closePopup;
    },

      openDialog () {
        let type = "ediUploadFile";
        let item = {
          ROWID : 0
        }
        let indexArrDialog = this.findDialog("ediUploadFile_0");
        if (indexArrDialog != null) {
          return;
        }
        this.newDialog(item, type) - 1;
      },

      newDialog (item, type) {
        return this.dialogs.push(this.generateDialog(item, type));
      },

    
      findDialog (id, dialogs) {
        if (!dialogs) dialogs = this.dialogs
        let index = dialogs.findIndex((val) => {
          return val.id === id
        })
        return (index > -1) ? index : null
      },

      generateDialog (item, type) {
        let id = `${type}_${item.ROWID}`;
        this.arrLayoutDialog.push({id : id});
        this.dialogId++
        let name = 'Dialog ' + id
        let options = {left : 30 * this.dialogId, top : 30 * this.dialogId};
        return { id, name, type, options }
      },

      dialogDragEnd (obj) {
        let index = this.findDialog(obj.id)
        this.$set(this.dialogs[index].options, 'left', obj.left)
        this.$set(this.dialogs[index].options, 'top', obj.top)
      },

      selectDialog (obj) {
        let index = this.findDialog(obj.id)
        this.selected = this.dialogs[index]
      },

      allowedDates(val){
        let date= getAppliedTimeZone();
        if(val <= date){
          return val;
        }
      },
      changePageByTextbox(value){
        let data = parseInt(this.pageEnter);
        if (isNaN(data)) {
          this.pageEnter = this.page;
          return;
        } else {
          this.page = data > this.pageCount ? this.pageCount : (data < 1 ? 1 : data);
          this.pageEnter = this.page;
        }
        this.page += value;
        this.initialize('pageChange');
      },
      caculatePageCount() {
        if(this.totalCnt % this.itemsPerPage === 0){
          this.pageCount = this.totalCnt / this.itemsPerPage;
        }else{
          this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
        }
      },
    },

    created () {
      this.$cookies.set('gmt-timezone', '+09:00', '7d');  // User정보 - GMT 시간
      console.log('-------------------server=>' + this.$route.params.server);
      if(this.$route.params.server === 'LIVE') this.$cookies.set('paproc-server', 'http://112.175.55.215:8181/', '7d'); 
      else if(this.$route.params.server === 'DEV') this.$cookies.set('paproc-server', 'http://202.20.84.134:8181/', '7d'); 
      else if(this.$route.params.server === 'ONE') this.$cookies.set('paproc-server', 'http://172.20.130.176:8181/', '7d'); 
      else this.$cookies.set('paproc-server', 'http://112.175.55.215:8181/', '7d'); 

      console.log('-------------------1) cookies server=>' + this.$cookies.get('paproc-server'));

      this.dateTimeFormat = config.dateTimeFormat;
      this.SummDataListItems=[];
      this.tooltipWidth = cfg.tooltipWidth;
      //this.queryList (this.$route.params.server);
      this.isCreated = true;
      this.initialize();
    },

    updated: function() {
      let self = this;
      let arrClassMinus = ['.page-control-content'];
      let arrClassPlus = [];

      if (this.isCreated) {
        let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
        self.tableHeight = h1 + "px";
        this.isCreated = false; 
      }

      $(window).resize(function (event) {
        let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
        self.tableHeight = h1 + "px";
      })
    },
  }
</script>

<style>
.v-data-table.elevation-1.monitoring-table.transaction-list .v-data-table-header th{
  font-size: 14px !important;
}

.monitoring-table .v-data-table-header th{
  text-align:center !important;
}
.theme--light .monitoring-table {
  min-height: 630px;
  max-height: 630px;
}
.theme--light .monitoring-table .v-data-table-header th{
  background: #496D94 !important;
  color:#FFFFFF !important;
}
.theme--light .monitoring-table tbody td{
  border-bottom: 1px solid #E0E6F2 !important;
  border-right: 1px solid #E0E6F2 !important;
}
.theme--light .monitoring-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background: #EAF1F8 !important;
}

</style>